import { Aplicacao } from './aplicacao.model';
import { InternetMonitoramento } from './internet-monitoramento.model';

export class AplicacaoMonitoramento {
  aplicacao: Aplicacao;
  internet: InternetMonitoramento;
}
